<template>
  <div>
    <!-- <el-select v-model="para.isEnd" placeholder="请选择" @change="handleChange()">
      <el-option value="N" label="有效">有效</el-option>
      <el-option value="Y" label="无效">无效</el-option>
  </el-select> -->
    <h1 class="textcenter">库存详情</h1>
    
    <div class="detail" v-for="n in list" :key="n.key">
        <div style="text-align: right; margin: 20px 0" v-if="(roleCode === 'administrator' || roleCode === 'admin')">
          <el-button type="primary"  @click="editstock(n)">编辑</el-button>
        </div>
        <div class="label-item">
          <div>
            <span>采购合同号</span>
            <span>{{ n.contractNum }}</span>
          </div>
          <div>
            <span>包装规格</span>
            <span>{{ n.packWeight }} {{ n.goodsSpec}}</span>
          </div>
        </div>

        <div class="label-item">
          <div>
            <span>商品名称</span>
            <span>{{ n.cnName? n.cnName: n.enName }}</span>
          </div>
          <div>
            <span>生产商</span>
            <span>{{ n.companyName }}</span>
          </div>
        </div>
        
        <div class="label-item">
          <div>
            <span>商品型号</span>
            <span>{{ n.model }}</span>
          </div>
          <div>
            <span>仓库地址</span>
            <span>{{ n.locationName }}</span>
          </div>
          
        </div>

        <div class="label-item" v-if="(roleCode === 'administrator' || roleCode === 'admin')">
          <div>
            <span>清关税</span>
            <span>{{ n.clearanceDuty }}</span>
          </div>
          <div>
            <span>清关汇率</span>
            <span>{{ n.exchangeRate }}</span>
          </div>
        </div>

        <div class="label-item">
          <div>
            <span>入库时间</span>
            <span>{{ formatime(n.entryTime) }}</span>
          </div>
          <div v-if="(roleCode === 'administrator' || roleCode === 'admin')">
            <span>汇率币种</span>
            <span>{{ n.currencyName }}</span>
          </div>
        </div>

         <div class="label-item"  v-if="(roleCode === 'administrator' || roleCode === 'admin')">
          <div>
            <span>采购合同PDF</span>
            <!-- <span>{{ n.purchaseContractUrl }}</span> -->
          </div>
            <el-button type="primary" @click="downloadpdf(n.purchaseContractUrl)" >预览下载</el-button>
        </div>

         <div class="label-item"  v-if="(roleCode === 'administrator' || roleCode === 'admin')">
          <div>
            <span>进口货物报关单</span>
          </div>
            <el-button type="primary" @click="downloadpdf(n.cargoDeclaration)" >预览下载</el-button>
        </div>

         <div class="label-item" >
          <div>
            <span>进仓核实单</span>
          </div>
            <el-button type="primary" @click="downloadpdf(n.verifySingle)" >预览下载</el-button>
        </div>

         <div class="label-item">
          <div>
            <span>检验检疫文件</span>
          </div>
            <el-button type="primary" @click="downloadpdf(n.healthCertificate)" >预览下载</el-button>
        </div>

        <div class="label-item">
          <div>
            <span>备注</span>
            <span>{{ n.remark }}</span>
          </div>
        </div>

        <div class="label-item">
          <el-table
            :data="n.batchNumDetailsVoList"
            style="width: 100%">
            <el-table-column
              prop="lotNum"
              label="批号"
              width="180">
            </el-table-column>
            <el-table-column
              prop="netWeight"
              label="入库净重"
              width="180">
            </el-table-column>
            <el-table-column
              prop="allowance"
              label="可用库存(净重)">
            </el-table-column>
            <el-table-column
              label="是否售完">
              <template slot-scope="scope">
                <div>{{ scope.row.soldOut === true? '已售完': '未售完' }}</div>
              </template>
            </el-table-column>

             <el-table-column
              label="coa">
              <template slot-scope="scope">
                <el-button type="primary" @click="downloadpdf(scope.row.coa)" >预览下载</el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>
        <div class="edit">
           <el-dialog
              :title="title"
              :visible.sync="centerDialogVisible"
              width="35%"
              center>
              <el-form :model="form">
                <!-- <el-form-item label="库位" :label-width="formLabelWidth">
                  <el-select v-model="form.locationId" placeholder="请选择">
                    <el-option
                        v-for="n in stocklist"
                        :key="n.key"
                        :label="n.locationName"
                        :value="n.id">
                      </el-option>
                  </el-select>
                </el-form-item> -->

                <el-form-item label="清关税" :label-width="formLabelWidth">
                  <el-input v-model="form.clearanceDuty"></el-input>
                </el-form-item>
                
                <el-form-item label="清关汇率" :label-width="formLabelWidth">
                  <el-input v-model="form.exchangeRate"></el-input>
                </el-form-item>
                
                <el-form-item label="汇率币种" :label-width="formLabelWidth">
                  <el-input v-model="form.currencyName"></el-input>
                </el-form-item>

                <el-form-item label="入库时间" :label-width="formLabelWidth">
                  <el-date-picker
                    v-model="form.entryTime"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>

                <el-form-item label="仓储地址" :label-width="formLabelWidth">
                  <el-select v-model="form.locationName" placeholder="请选择">
                      <el-option
                      v-for="item in stockadresslist"
                      :key="item.key"
                      :label="item.address"
                      :value="item.address">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="采购合同号pdf" class="cghthstyle" label-width="120px" style="margin-left:34px;">
            
                    <el-upload
                      class="upload-demo"
                      :data="qiniu"
                      action="https://upload.qiniup.com"
                      :show-file-list="true"
                      :multiple="false"
                      :file-list="purchaseContractUrl"
                      :before-upload="(file) => {return handleBeforeUpload(file, 'purchaseContractUrl')}"
                      :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'purchaseContractUrl') }"
                      :on-remove="(file, fileList) => { return handleOnRemove(file, fileList, 'purchaseContractUrl') }"
                    >
                      <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                  </el-form-item>

              <el-form-item label="进口货物报关单" class="cghthstyle" label-width="120px" style="margin-left:34px;">
            
                <el-upload
                  class="upload-demo"
                  :data="qiniu"
                  action="https://upload.qiniup.com"
                  :show-file-list="true"
                  :multiple="false"
                  :file-list="cargoDeclaration"
                  :before-upload="(file) => {return handleBeforeUpload(file, 'cargoDeclaration')}"
                  :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'cargoDeclaration') }"
                  :on-remove="(file, fileList) => { return handleOnRemove(file, fileList, 'cargoDeclaration') }"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>


              <el-form-item label="进仓核验单" class="cghthstyle" label-width="120px" style="margin-left:34px;">
                
                <el-upload
                  class="upload-demo"
                  :data="qiniu"
                  action="https://upload.qiniup.com"
                  :show-file-list="true"
                  :multiple="false"
                  :file-list="verifySingle"
                  :before-upload="(file) => {return handleBeforeUpload(file, 'verifySingle')}"
                  :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'verifySingle') }"
                  :on-remove="(file, fileList) => { return handleOnRemove(file, fileList, 'verifySingle') }"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
                
                <el-form-item label="备注" :label-width="formLabelWidth">
                  <el-input v-model="form.remark"></el-input>
                </el-form-item>


                <div  v-for="(n, index) in form.batchNumDetailsVoList" :key="n.keys">

              <div class="disflexbtw">
                
                <div hidden>
                  <el-form-item
                    :label="'id' + parseInt(index+1)"
                  >
                  <el-input v-model="form.batchNumDetailsVoList[index].id"></el-input>
                  </el-form-item>
                </div>

                <div hidden>
                  <el-form-item
                    :label="'破包id' + parseInt(index+1)"
                  >
                  <el-input v-model="form.batchNumDetailsVoList[index].breakId"></el-input>
                  </el-form-item>
                </div>

                <div>
                  <el-form-item
                    :label="'破包批号' + parseInt(index+1)"
                  >
                  <el-input v-model="form.batchNumDetailsVoList[index].lotNum"></el-input>
                  </el-form-item>
                </div>
                
                <div>
                  <el-form-item
                    :label="'破包数量' + parseInt(index+1)"
                  >
                  <el-input v-model="form.batchNumDetailsVoList[index].breakNum"></el-input>
                  </el-form-item>
                </div>
                <!-- <div>
                  <el-button @click.prevent="handleRemovePara(n)" type="danger">删除</el-button>
                </div> -->
              </div>
            </div>
              
            <!-- <div style="display:flex;justify-content: flex-end">
              <el-form-item >
                <el-button @click="handleAddPara()">新增参数</el-button>
              </el-form-item>
            </div> -->

              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handlesuccess()">确 定</el-button>
              </span>
            </el-dialog>
        </div>
    
    
    </div>

     <div style="text-align:center;">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="(value) => {return handleSearch(value)}"
          :current-page="para.pageIndex"
          :total="total">
        </el-pagination>
      </div>
      <div style="float:right">
        <el-button type="info" @click="handleBack">返回</el-button>
      </div>
  </div>
</template>

<script>
import { stockquerydetails, addressfindByCompanyId, qiniuupload, qiniugetDown, stocklocationfindAll, stockupdatestock } from '../../api'
import utils from '../../../public/utils'
import qs from 'qs'
import moment from 'moment'
export default {
  data () {
    return {
      ident: '',
      list: [],
      stocklist: [],
      stockadresslist: [], //  仓储地址列表
      purchaseContractUrl: [],
      cargoDeclaration: [],
      verifySingle: [],
      centerDialogVisible: false,
      form: { //  新增初始化form
        purchaseContractUrl: '',
        cargoDeclaration: '',
        verifySingle: '',
        breakPackages: [],
      },
      qiniu: { //  qiniu
        token: '',
        key: ''
      },
      uploadUrl: '', //  上传地址前缀
      formLabelWidth: '120px',
      sts: 0, //  0 添加, 1 编辑
      roleCode: '',
      title: '编辑', //  添加窗口标题
      para: {
        pageIndex: 1,
        pageSize: 10,
        goodsId: '',
        isEnd: null,
      },
      total: 0,
    }
  },
  mounted () {
    let obj = this.$router.app._route.query.name
    console.log(obj)
    // this.ident = obj
    // console.log(this.ident.goodsId)
    this.para.goodsId = obj.goodsId
    this.para.isEnd = obj.isEnd
    let roleCode = sessionStorage.getItem('roleCode')
    console.log(roleCode)
    this.roleCode = roleCode
    this.getToken()
    this.getstockquerydetails()
  },
  methods: {
    handleChange () {
      this.getstockquerydetails()
    },
    handleRemovePara (item) { //  删除参数
      let dom = this.form.batchNumDetailsVoList
      if (dom.length <= 1) {
        this.$message.error('至少一个参数')
      } else {
        var index = dom.indexOf(item)
        if (index !== -1) {
          dom.splice(index, 1)
        }
      }
    },
    handleAddPara () { //  新增参数
      this.form.batchNumDetailsVoList.push(
        {
          id: '', //  批号id
          lotNum: '',
          breakNum: '', //  批号销售数量
        },
      )
    },
    getToken () { //  获取qiniu的token
      let para = new URLSearchParams()
      para.append('bucket', 'compact')
      qiniuupload(para).then((res) => {
        console.log(res.data)
        this.qiniu.token = res.data.uploadToken
        this.uploadUrl = res.data.url
      })
    },
    handleBack () {
      this.$router.push({ path: '/kclist' })
    },
    handleSearch (val) {
      console.log(val)
      this.para.pageIndex = val
      this.getstockquerydetails()
    },
    handleBeforeUpload (file, type) { //  上传之前
      this.qiniu.key = type + `${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess (response, file, fileList, type) { //  上传成功之后
      this.form[type] = this.uploadUrl + '/' + response.key
      this[type].push({
        name: response.key,
        url: this.uploadUrl + response.key
      })
    },
    handleOnRemove (file, fileList, type) {
      this[type] = []
    },
    getaddressfindByCompanyId (companyId) { //  根据公司ID查询该公司的仓储地址
      let para = {
        companyId: companyId,
        typeId: 3
      }
      addressfindByCompanyId(para).then(data => {
        console.log(data)
        this.stockadresslist = data.data.data
        // this.stockadresslist.push()
      })
    },
    handlesuccess () { //  提交表单信息
      // this.form.shipBusinessId = 1
      this.form.entryTime = this.formatime(this.form.entryTime)
      this.form.address = this.form.locationName

      this.form.breakPackages = []
      let arr = this.form.batchNumDetailsVoList
      
      arr.forEach(element => {
        let arrlist = {}
        if (element['breakId']) {
          arrlist['id'] = element['breakId']
        } else {
          arrlist['id'] = null
        }
        arrlist['lotNumId'] = element['id']
        arrlist['breakNum'] = element['breakNum']
        this.form.breakPackages.push((arrlist))
      })
      this.form.breakPackages = JSON.stringify(this.form.breakPackages)
      // console.log(this.form.batchNumDetailsVoList)
      this.form.purchaseContract = this.form.purchaseContractUrl
      let para = new URLSearchParams(this.form)
      stockupdatestock(para).then(data => {
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.centerDialogVisible = false
        }
      })
    },
    getstocklocationfindAll () { //  库位列表
      let para = {
        status: 1
      }
      stocklocationfindAll(para).then(data => {
        console.log(data.data.data)
        this.stocklist = data.data.data
      })
    },
    downloadpdf (w) {
      let para = new URLSearchParams()
      para.append('baseUrl', w)
      qiniugetDown(para).then(data => {
        console.log(data.data)
        window.open(data.data)
      })
    },
    editstock (n) { //  编辑
      this.centerDialogVisible = true
      this.form = n
      console.log(n)
      this.getaddressfindByCompanyId(this.form.companyId)

      this.purchaseContractUrl = []
      this.purchaseContractUrl.push({
        name: this.formatName(this.form.purchaseContractUrl),
        url: this.form.purchaseContractUrl
      })

      this.cargoDeclaration = []
      this.cargoDeclaration.push({
        name: this.formatName(this.form.cargoDeclaration),
        url: this.form.cargoDeclaration
      })

      this.verifySingle = []
      this.verifySingle.push({
        name: this.formatName(this.form.verifySingle),
        url: this.form.verifySingle
      })
      
     

      this.getstocklocationfindAll()
    },
    getstockquerydetails () { // 查询详情列表
      // let obj = {
      //   'goodsId': this.para.goodsId,
      //   'pageIndex': this.para.pageIndex,
      //   'pageSize': this.para.pageSize
      // }
      let para = new URLSearchParams(this.para)
      stockquerydetails(para).then( data => {
        console.log(data)
          this.list = data.data.rows
          this.total = data.data.total
          // this.total = 44
      })
    },
    formatName (s) {
      if (s) {
        return s.substr(38)

      }
      // "http://seatransportation.cuican520.cn/packingList201902261115793321.zip"
    },
    formatime (s) { //  格式化时间
      let a = utils.formatterTime(s)
      return a
    },
  }
}
</script>
<style lang="stylus" scoped>
.textcenter
  text-align center
  margin-bottom 30px
.detail
  border 1px solid #ccc
  padding 20px
  margin-bottom 10px
.label-item
  display flex
  justify-content space-between
  line-height 2em
  div>span
    text-align right
    display inline-block
  span
    margin-left 30px
</style>